import { Link } from 'react-router-dom'
import { Brand } from './Brand'

export function Footer() {
  return (
    <footer className="footer">
      <div><Brand inverse /></div>
      <div className="footer__grid">
        <div><strong>ATENDIMENTO</strong><Link to="/contato">Contato</Link><Link to="/trocas">Trocas e devoluções</Link></div>
        <div><strong>INSTITUCIONAL</strong><Link to="/privacidade">Privacidade</Link><Link to="/termos">Termos</Link></div>
        <div><strong>GK MAISON</strong><span>Moda contemporânea</span><span>Brasil</span></div>
      </div>
      <small>© {new Date().getFullYear()} GK Maison. Todos os direitos reservados.</small>
    </footer>
  )
}
